module.exports = __webpack_public_path__ + "img/verify-id.ef120c51.png";